import React from 'react';

function Header({ onLoadExample, inputs }) {
  return (
    <header>
      <div className="brand">
        <div style={{ flex: 1 }}>
          <h1 style={{fontSize: "36px", marginBottom: "12px"}}>IOTA Payment Estimator</h1>
          <p className="lead" style={{fontSize: "15px", marginBottom: "4px", fontWeight: "700"}}>Unofficial estimate of the IOTA payments per Medicare FFS transplant. <a href="https://www.govinfo.gov/content/pkg/FR-2024-12-04/pdf/2024-27841.pdf">Full Model</a></p>
          <p className="lead">Default values are from the last SRTR report, July 2024 - July 2025</p>
        </div>
      </div>
      <div className="header-logo">
        <a href="https://projectdonor.org" target="_blank" rel="noopener noreferrer">
          <img src="/logo_pd.png" alt="Project Donor Logo" className="header-logo-image" />
        </a>
      </div>
    </header>
  );
}

export default Header;
